jQuery(document).ready(function($) {

    $( ".bloc_parafond" ).each(function( index ) {

        var parent = $(this)
        var contenu = parent.find(".contenu")

        gsap.from( contenu, {
            y : +200,
            opacity : 0,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 50%",
                scrub: 1,
            }

        })

    })

});